<mat-card appearance="outlined">

    <mat-card-header>
        <mat-card-title>Conductor Metal Prices [LME]</mat-card-title>
    </mat-card-header>

    <mat-card-content>
        <div [innerHTML]="vm.metalPrices" class="v-metal-prices"></div>
    </mat-card-content>

    @if (vm.showProgressBar) {
    <mat-card-footer>
        <mat-progress-bar></mat-progress-bar>
    </mat-card-footer>
    }

</mat-card>

